/**
 * CANONICAL FIREBASE ENTRY POINT
 * ==============================
 * This is the ONLY file that should initialize Firebase.
 * All other files must import { auth, db, storage, rtdb } from here.
 *
 * DO NOT call initializeApp() anywhere else in the codebase.
 * See FIREBASE_CANONICAL_ENTRY.md for enforcement rules.
 */

import { initializeApp, getApps } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

// Runtime guard: detect if Firebase was initialized elsewhere before this file loaded
if (getApps().length > 0) {
  console.warn(
    '[Firebase] WARNING: Firebase was already initialized before canonical entry point!\n' +
    'This indicates a duplicate initializeApp() call somewhere in the codebase.\n' +
    'Stack trace:',
    new Error().stack
  );
}

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
